import { FadeIn } from './fade-in';
import { ImageBackground } from './image-background';

import { Button } from '~/components/ui/button';
import { ArrowUpRight } from '~/components/ui/icons';
import { SOCIAL_LINKS } from '~/constants';

interface ProductCTASectionProps {
  title: string;
  heading: string;
  button1Text: string;
  backgroundImage: string;
  imageClassName?: string;
}

export const ProductCTASection = ({
  title,
  heading,
  button1Text,
  backgroundImage,
  imageClassName,
}: ProductCTASectionProps) => {
  return (
    <section className="relative w-full h-[600px] md:h-[705px] overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center">
        <div>
          <ImageBackground
            imageUrl={backgroundImage}
            className={imageClassName}
          />
        </div>
      </div>

      {/* Gradient overlay: heavier at top & bottom, lighter in center */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/30 to-black/70" />
      {/* Radial vignette for darker edges */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_30%,rgba(0,0,0,0.5)_100%)]" />

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="flex flex-col gap-7 items-center text-center text-white px-4">
          <FadeIn>
            <div className="flex flex-col gap-3">
              <p className="font-mono text-sm tracking-[0.14px] uppercase">
                {title}
              </p>
              <p className="text-[32px] md:text-[48px] font-medium leading-[1.2] tracking-[0.32px] md:tracking-[0.48px]">
                {heading}
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2}>
            <div className="flex flex-col items-center md:flex-row gap-4 md:gap-7 w-full md:w-auto">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  window.open(SOCIAL_LINKS.LINKEDIN, '_blank', 'noopener,noreferrer');
                }}
                variant="glass"
                className="px-[24px] py-[10px] text-base"
              >
                {button1Text}
                <ArrowUpRight className="size-[16px]" />
              </Button>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};
